console.log("init Proteus treatments -- 1.01")

// support for [BON-12]

window.bon12_v = "v0";
// window.sessionStorage.setItem("[BON-12] v1", "active")

waitForElement('rubik-swatch').then(swatches => {

    waitUntil(() => {
        return window.bon12_v == 1 || window.sessionStorage.getItem("[BON-12] v1");
    }).then(() => {
        if(!window.sessionStorage.getItem("[BON-12] v1: redirected") || window.location.href.indexOf("variant=") == -1){
            // redir to select the default
            window.sessionStorage.setItem("[BON-12] v1: redirected", true)
            window.location.href = window.location.pathname + "?variant=52309721547061"
        }
    }).catch();

    let apply_css = () => {

        let css_def = `.rubik-swatch__item-wrapper:not(:nth-child(-n+4))`;
        if(window.bon12_v == 1 || window.sessionStorage.getItem("[BON-12] v1")){
            css_def = `.rubik-swatch__item-wrapper:nth-child(-n+4)`;
        }
        swatches.shadowRoot.querySelector('.rubik-swatch').insertAdjacentHTML("afterbegin", `
            <style id="js-bon12">
            ${css_def}{
                display: none;
            }
            </style>    
        `);
    };

    waitUntil(() => {
        return swatches?.shadowRoot?.querySelectorAll('.rubik-swatch')?.length > 0;
    }).then(() => {

        apply_css();
        setInterval(() => {
            if(swatches.shadowRoot.querySelectorAll('style#js-bon12').length == 0){
                apply_css();
            }
        }, 50);

        const interval = setInterval(() => {
            if (swatches.shadowRoot.querySelectorAll('style#js-bon12').length === 0) {
                apply_css();
            }
        }, 50);

        // stop after 10s
        setTimeout(() => {
        clearInterval(interval);
        }, 1000);


    }).catch();

}).catch();
// end support for [BON-12]